import React from "react";
import classes from "./Loader.module.scss"
export default function Loader(props) {
  return (
    <div className={`${classes.loader_container} ${classes[props.type]}`}/>
  );
}
